export default __webpack_public_path__ + "static/media/PNSLogoIcon.3c392c0a.svg";